import { Controller } from "@hotwired/stimulus";

// Toggles visibility of "specific amounts" form sections vs. the
// "range only" range inputs based on the Valuation type radio choice.
// Used on the offer letter form (admin/bids/_form).
//
// Switching modes will null the other side's values on save (server-side
// reset in BidsController#apply_valuation_mode_resets), so we surface a
// confirm dialog if the user is about to leave a side with populated data.
// Cancelling re-checks the previously selected radio.
export default class extends Controller {
  static targets = ["specificAmountSection", "rangeSection"];

  showRangeMode (event) {
    if (this.hasPopulatedInputs(this.specificAmountSectionTargets) && !this.confirmSwitch()) {
      this.revertRadio(event, "false");
      return;
    }

    this.specificAmountSectionTargets.forEach(el => el.classList.add("hidden"));
    this.rangeSectionTargets.forEach(el => el.classList.remove("hidden"));
  }

  showSpecificMode (event) {
    if (this.hasPopulatedInputs(this.rangeSectionTargets) && !this.confirmSwitch()) {
      this.revertRadio(event, "true");
      return;
    }

    this.specificAmountSectionTargets.forEach(el => el.classList.remove("hidden"));
    this.rangeSectionTargets.forEach(el => el.classList.add("hidden"));
  }

  hasPopulatedInputs (sections) {
    return sections.some(section =>
      Array.from(section.querySelectorAll("sl-input, input")).some(input => {
        if (input.type === "radio" || input.type === "checkbox") return false;
        const val = (input.value || "").toString().trim();
        return val !== "" && val !== "0";
      }),
    );
  }

  confirmSwitch () {
    return window.confirm(
      "Switching valuation type will clear the other section's values when you save. Continue?",
    );
  }

  revertRadio (event, otherValue) {
    const name = event.target.name;
    const other = document.querySelector(`input[type="radio"][name="${name}"][value="${otherValue}"]`);
    if (other) other.checked = true;
  }
}
